import { render } from "./BuyingCampaignEdit.vue?vue&type=template&id=53ec6d2f&scoped=true&ts=true"
import script from "./BuyingCampaignEdit.vue?vue&type=script&lang=ts"
export * from "./BuyingCampaignEdit.vue?vue&type=script&lang=ts"

import "./BuyingCampaignEdit.vue?vue&type=style&index=0&id=53ec6d2f&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ec6d2f"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QBtn,QTabs,QTab,QTabPanels,QTabPanel});
